const MeetingStatus = {
  Loading: 'Loading',
  Suceeded: 'Succeeded',
  Failed: 'Failed',
  Waiting: 'Waiting',
};

export default MeetingStatus;
